<form #form="ngForm" class="form-horizontal">
    <div class="mon-dialog-header">
        <page-header [header]="'Import rules' | translate"></page-header>
    </div>
    <div class="mon-dialog-body-with-footer">
        <div class="card panel-monsido-card mt-3 mx-3" *ngIf="step === 1">
            <div class="card-header">
                <h3 class="font-weight-300" translate>Upload CSV</h3>
            </div>
            <div class="card-body">
                <form-rule-import-upload [(data)]="data" [(step)]="step"></form-rule-import-upload>
            </div>
        </div>

        <div class="card panel-monsido-card mt-3 mx-3" *ngIf="step === 2">
            <div class="card-header">
                <h3 class="font-weight-300" translate>Select import</h3>
            </div>
            <div class="card-body">
                <form-rules-import-setup *ngIf="step === 2" [data]="data" [selected]="selected" [step]="step"></form-rules-import-setup>
            </div>
        </div>

        <div class="card panel-monsido-card mt-3 mx-3" *ngIf="step === 3">
            <div class="card-header">
                <h3 class="font-weight-300" translate>Confirm</h3>
            </div>
            <div class="card-body">
                Import {{ (data?.data?.length || 0) - 1 }} rules?
            </div>
        </div>
    </div>
    <div class="mon-dialog-footer text-right">
        <button class="btn btn-border-radius btn-secondary" [disabled]="saving || form.invalid" *ngIf="step === 2" translate (click)="step = 3">
            Next
        </button>
        <button class="btn btn-border-radius btn-secondary" (click)="submit()" *ngIf="step === 3">
            <span *ngIf="!saving" translate>Import rules</span>
            <span [class]="getSpinner()" aria-hidden="true"></span>
        </button>
    </div>
</form>
